import {defineMessages} from "react-intl";

// Message structure for FAQ component
export const FAQ_MESSAGES = {
  Faq1: [
    {
      title: defineMessages({
        message: {
          id: 'Sell.FAQ.Answer1.highlight',
          defaultMessage: "It's easy!"
        }
      }),
      subtitle: defineMessages({
        message: {
          id: 'Sell.FAQ.Answer1.content1',
          defaultMessage: "1. Sign in or create a StubHub account to get started selling tickets."
        }
      })
    },
    {
      subtitle: defineMessages({
        message: {
          id: 'Sell.FAQ.Answer1.content2',
          defaultMessage: "2. Include the number of tickets you're selling, the seats, and delivery details in your listing."
        }
      })
    },
    {
      subtitle: defineMessages({
        message: {
          id: 'Sell.FAQ.Answer1.content3',
          defaultMessage: "3. Set your price and wait for the buyers to come to you!."
        }
      })
    }
  ],
  Faq2: [
    {
      title: defineMessages({
        message: {
          id: 'Sell.FAQ.Answer2.highlight',
          defaultMessage: "We've made it impossibly easy to list your tickets on StubHub."
        }
      }),
      subtitle: defineMessages({
        message: {
          id: 'Sell.FAQ.Answer2.content',
          defaultMessage: "Thanks to our massive catalog of events, you can sell tickets to almost any event in just three steps! Just sign in, tell us what concert tickets you're selling, and set your price."
        }
      })
    }
  ],
  Faq3: [
    {
      title: defineMessages({
        message: {
          id: 'Sell.FAQ.Answer3.highlight',
          defaultMessage: "Listing on StubHub is as easy as 1-2-3"
        }
      }),
      subtitle: defineMessages({
        message: {
          id: 'Sell.FAQ.Answer3.content',
          defaultMessage: "Just sign in to the app or on your mobile browser, tell us what tickets you're selling, and set your price. When you have a buyer, we'll give you the added benefit of providing instructions on how to deliver the tickets to them."
        }
      })
    }
  ],
  Faq4: [
    {
      title: defineMessages({
        message: {
          id: 'Sell.FAQ.Answer4.highlight1',
          defaultMessage: "Mobile transfer"
        }
      }),
      subtitle: defineMessages({
        message: {
          id: 'Sell.FAQ.Answer4.content1',
          defaultMessage: "Tickets are in the online account where you bought them (the team, Ticketmaster, etc.)"
        }
      })
    },
    {
      title: defineMessages({
        message: {
          id: 'Sell.FAQ.Answer4.highlight2',
          defaultMessage: "Flash Seats"
        }
      }),
      subtitle: defineMessages({
        message: {
          id: 'Sell.FAQ.Answer4.content2',
          defaultMessage: "Mobile-only tickets stored in a Flash Seats (AXS) account."
        }
      })
    },
    {
      title: defineMessages({
        message: {
          id: 'Sell.FAQ.Answer4.highlight3',
          defaultMessage: "Barcode"
        }
      }),
      subtitle: defineMessages({
        message: {
          id: 'Sell.FAQ.Answer4.content3',
          defaultMessage: "Tickets that use barcodes to validate. Enter the barcode on your tickets to deliver them."
        }
      })
    },
    {
      title: defineMessages({
        message: {
          id: 'Sell.FAQ.Answer4.highlight4',
          defaultMessage: "Paper tickets"
        }
      }),
      subtitle: defineMessages({
        message: {
          id: 'Sell.FAQ.Answer4.content4',
          defaultMessage: "Traditionally-printed tickets, wristbands, or tickets printed at home."
        }
      })
    },
    {
      title: defineMessages({
        message: {
          id: 'Sell.FAQ.Answer4.highlight5',
          defaultMessage: "PDF tickets"
        }
      }),
      subtitle: defineMessages({
        message: {
          id: 'Sell.FAQ.Answer4.content5',
          defaultMessage: "Original .PDF files on your computer or mobile device."
        }
      })
    },
    {
      title: defineMessages({
        message: {
          id: 'Sell.FAQ.Answer4.highlight6',
          defaultMessage: "Pickup tickets"
        }
      }),
      subtitle: defineMessages({
        message: {
          id: 'Sell.FAQ.Answer4.content6',
          defaultMessage: "Hard tickets you can deliver to one of our Last Minute Services (LMS) location."
        }
      })
    }
  ]
};
